import { useRef, useEffect } from 'react';
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import useMap from '@components/operatorLobby/useMap';

export default function DashboardMap({ vehicles, selectedVehicle }) {
  const { mapRef, mapContainerRef, updateMapCenter } = useMap(vehicles, [selectedVehicle.localization.longitude, selectedVehicle.localization.latitude], 18, selectedVehicle.id);
  const boundMap = useRef(true);

  useEffect(() => {
    const bounds = new mapboxgl.LngLatBounds();

    vehicles.forEach((vehicle) => {
      const localization = vehicle.localization;
      if (localization) {
        if (localization.longitude && localization.latitude) {
          const coordinates = new mapboxgl.LngLat(localization.longitude, localization.latitude);
          bounds.extend(coordinates);
        } else {
          console.log('No valid coordinates for vehicle', vehicle.id);
        }
      }
    });

    if (bounds.length > 0 && boundMap.current) {
      // bound the map only the first time
      mapRef.current.fitBounds(bounds, { padding: 50 });
      boundMap.current = false;
    }
  }, [vehicles, mapRef]);

//   // Update map center when vehicle location changes
//   useEffect(() => {
//     // console.log(selectedVehicleId);
//     // console.log(vehicles);
//     const vehicle = vehicles.find(vehicle => vehicle.id === selectedVehicle);
//     if (vehicle && vehicle.localization) {
//       updateMapCenter([vehicle.localization.longitude, vehicle.localization.latitude]);
//     }
//   }, [vehicles, selectedVehicle, updateMapCenter]);

  return <div ref={mapContainerRef} className="map-container"></div>;
}
